import React, { useState } from "react";
import { Input } from "nav-frontend-skjema";
import { Hovedknapp, Flatknapp } from "nav-frontend-knapper";
import { AlertStripeFeil } from "nav-frontend-alertstriper";

import { phoneService } from "../../api";

interface Props {
  phone: string;
  onVerified: () => void;
  onStartOver: () => void;
}

export const OtpStep = ({ phone, onVerified, onStartOver }: Props) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(false);
    let verified = false;
    try {
      await phoneService.verifyOtp(phone, code);
      verified = true;
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
    if (verified) {
      onVerified();
    }
  };

  return (
    <>
      <h1>Bekreft telefonnummeret</h1>
      <p>
        Vi har sendt en engangskode på SMS til {phone}.<br />
        Skriv den inn under.
      </p>
      <form onSubmit={submit}>
        <Input
          id="code"
          type="text"
          label="Engangskode"
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        {error && (
          <AlertStripeFeil role="alert">Feil kode. Prøv igjen.</AlertStripeFeil>
        )}
        <Hovedknapp
          htmlType="submit"
          spinner={submitting}
          disabled={submitting || code.length !== 6}
        >
          Bekreft
        </Hovedknapp>
        <Flatknapp htmlType="button" onClick={onStartOver}>
          Bruk et annet nummer
        </Flatknapp>
      </form>
    </>
  );
};
